import { Form, FormInstance, Row } from "antd";
import { FloatNumberInput } from "../../../FloatNumberInput";
import { Rule } from "antd/es/form";
import { useMemo } from "react";
import { transformToFloat } from "../../../../lib/transformToFloat";

type AfterOptionProps = {
  form: FormInstance;
};

export const AfterOption = ({ form }: AfterOptionProps) => {
  const endConditionType = Form.useWatch("endConditionType", form);

  const rules: Rule[] = useMemo(() => {
    return [
      () => ({
        validateTrigger: "onSubmit",
        validator(_: Rule, value: string) {
          const val: number | null = transformToFloat(value);

          if (endConditionType === 1) {
            return val ? Promise.resolve() : Promise.reject(new Error(""));
          }

          return Promise.resolve();
        },
      }),
    ];
  }, [endConditionType]);

  return (
    <Row className="align-center">
      <span className="mr-8">After</span>
      <FloatNumberInput
        className="mb-0 after-input mr-2"
        name="maxOccurrences"
        label=""
        prefix=""
        allowDecimal={false}
        disabled={endConditionType !== 1}
        form={form}
        rules={rules}
      />
      <span>occurrences</span>
    </Row>
  );
};
